import React from 'react';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
const ColumnItem = (props) => {
    const { className, icon, title, description, href, openExternal, style, LinkComponent = 'a', } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('footer-item');
    const cls = classnames(prefixCls, className);
    return (React.createElement("div", { className: cls, style: style },
        React.createElement(LinkComponent, { href: href, to: typeof LinkComponent !== 'string' ? href : undefined, target: openExternal ? '_blank' : undefined, rel: openExternal ? 'noopener noreferrer' : undefined },
            icon && React.createElement("span", { className: `${prefixCls}-icon` }, icon),
            title),
        description && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: `${prefixCls}-separator` }, "-"),
            React.createElement("span", { className: `${prefixCls}-description` }, description)))));
};
export default ColumnItem;
